// import React from 'react';
// import FeatureCard from '../../../../styles/FeatureCard.js';

// import agent from '../../../../assets/services/hostedinfrastructure/icons/multilayered.png';
// import AP from '../../../../assets/services/hostedinfrastructure/icons/selfportal.png';
// import HW from '../../../../assets/services/hostedinfrastructure/icons/affordablepricing.png';
// import efficientStorage from '../../../../assets/services/hostedinfrastructure/icons/storage.png';
// import WO from '../../../../assets/services/hostedinfrastructure/icons/multisecuregeolocations.png';
// import EA from '../../../../assets/services/hostedinfrastructure/icons/availability.png';
// import protection from '../../../../assets/services/hostedinfrastructure/icons/securebackup.png';
// import support from '../../../../assets/services/hostedinfrastructure/icons/support.png';
// import cloud from '../../../../assets/services/hostedinfrastructure/icons/cloudmigration.png';

// const Cards = () => {
//   return (
//     <div className="disastercards disastercards-padding my-0 my-md-4">

//       <div className="disastercards-row">
//         <FeatureCard
//           image={agent}
//           title="What can you host?"
//           description={
//             <ul>
//               <li>Linux and Windows servers for business workloads</li>
//               <li>Databases and enterprise applications (including open-source stacks)</li>
//               <li>Enterprise websites and web applications (public-facing or internal portals)</li>
//               <li>Kubernetes (K8s) platforms for containerization and microservices</li>
//               <li>VDI-ready hosting (secure virtual desktops for remote work and controlled access)</li>
//             </ul>
//           }
//         />

//         <FeatureCard
//           image={AP}
//           title="Security-first cloud with Zero Trust approach"
//           description={
//             <><p> We design security onto the platforms, not as an add-on. Our hosting key controls can include: </p><ul>
//               <li>Zero Trust access principles (least privilege, continuous verification)</li>
//               <li>MFA + role-based access control for administrators and users</li>
//               <li>Firewall policies and traffic segmentation to isolate workloads</li>
//               <li>SSL-VPN / secure access gateways where required</li>
//               <li>Vulnerability scanning and hardening aligned to best practices</li>
//               <li>IPS/IDS, IOC-based monitoring for threat detection</li>
//               <li>Ransomware resilience with immutable/secure backup options and recovery workflows</li>
//             </ul></>
//           }
//         />
//       </div>

//       <div className="disastercards-row">
//         <FeatureCard
//           image={HW}
//           title="Pricing and quote"
//           description={
//             <><p>
//               Our secure hosted solutions are designed to be cost-effective compared to others for many enterprise workloads, with predictable monthly pricing and support options. You can choose from a wide variety of Virtual Machine Configuration and Storage Performance classes configured for specific types of workloads for your business needs.
//             </p><p>For a quick customized quote, contact info@synectiks.com.</p></>
//           }
//         />
//       </div>

//       <div className="disastercards-row">
//         <FeatureCard
//           image={efficientStorage}
//           title="Storage, backup, and disaster recovery"
//           description={
//             <ul>
//               <li>Object storage (S3-compatible) and scalable capacity from TBs to PBs</li>
//               <li>High-performance SSD block storage for servers and VDI workloads</li>
//               <li>Backup options for servers, VMs, endpoints, and critical apps</li>
//               <li>Disaster recovery options (backup-based restore or DR replication—based on RPO/RTO needs)</li>
//               <li>Cyber protection features integrated into backup/DR to reduce ransomware impact</li>
//             </ul>
//           }
//         />

//         <FeatureCard
//           image={WO}
//           title="Networking and geo-resilience"
//           description={
//             <ul>
//               <li>Each location is separated by Seismic Zone, Power Grid to make sure your Infrastructure is always available when disaster strikes at one location.</li>
//               <li>Secure networking design (subnets, segmentation, routing, and policy-based controls)</li>
//               <li>Secure networking design (subnets, segmentation, routing, and policy-based controls)</li>
//               <li>Locations can be selected to reduce correlated risk (power grid, seismic zone separation)</li>
//               <li>Options for multi-site DR and geo-backup based on recovery needs</li>
//             </ul>
//           }
//         />
//       </div>

//       <div className="disastercards-row">
//         <FeatureCard
//           image={EA}
//           title="Self-service portal (governance with simplicity)"
//           description={
//             <><p>Manage and control your hosted environment through an easy portal:</p><ul>
//               <li>Provision and manage compute, storage, backup, and DR</li>
//               <li>View security status, policies, and operational controls</li>
//               <li>Track usage and billing visibility for cost management</li>
//             </ul></>
//           }
//         />

//         <FeatureCard
//           image={protection}
//           title="Compliance and governance (SoC2 & HIPAA)"
//           description={
//             <><p>We support compliance-driven hosting by enabling:</p><ul>
//               <li>Access logging and audit trails</li>
//               <li>Security baseline controls and documented processes</li>
//               <li>Backup/retention policies aligned to business and regulatory needs</li>
//               <li>Support for meeting common enterprise compliance expectations (as applicable)</li>
//               <li>Security Awareness Training (SAT)</li>
//             </ul></>
//           }
//         />
//       </div>

//       <div className="disastercards-row">
//         <FeatureCard
//           image={cloud}
//           title="Migration and modernization"

//           description={
//             <><p>Our teams support both lift-and-shift and transformation programs:</p><ul>
//               <li>Cloud migration planning (application discovery, risk assessment, phased cutover)</li>
//               <li>Modernization using cloud-native patterns (containers, microservices, managed services)</li>
//               <li>Performance and security validation after migration</li>
//               <li>Outcome-focused delivery aligned to reliability, scalability, and cost control</li>
//             </ul></>
//           }
//         />

//         <FeatureCard
//           image={support}
//           title="24x7 Support"
//           description={
//             <ul>
//               <li>24/7/365 operations support with onshore and offshore coverage</li>
//               <li>Incident response coordination, escalation, and recovery support</li>
//               <li>Proactive monitoring for availability, performance, and security signals</li>
//             </ul>
//           }
//         />
//       </div>

//     </div>
//   );
// };

// export default Cards;











// import React from 'react';
// import FeatureCard from '../../../../styles/FeatureCard.js';// Ensure path is correct
// import '../../../../styles/disasterCard.css'; // Ensure CSS is imported

// // Import your images...
// import agent from '../../../../assets/services/hostedinfrastructure/icons/multilayered.png';
// import AP from '../../../../assets/services/hostedinfrastructure/icons/selfportal.png';
// import HW from '../../../../assets/services/hostedinfrastructure/icons/affordablepricing.png';
// import efficientStorage from '../../../../assets/services/hostedinfrastructure/icons/storage.png';
// import WO from '../../../../assets/services/hostedinfrastructure/icons/multisecuregeolocations.png';
// import EA from '../../../../assets/services/hostedinfrastructure/icons/availability.png';
// import protection from '../../../../assets/services/hostedinfrastructure/icons/securebackup.png';
// import support from '../../../../assets/services/hostedinfrastructure/icons/support.png';
// import cloud from '../../../../assets/services/hostedinfrastructure/icons/cloudmigration.png';

// const Cards = () => {
//   const cardData = [
//     {
//       image: agent,
//       title: "What can you host?",
//       description: (
//         <ul>
//           <li>Linux and Windows servers for business workloads</li>
//           <li>Databases and enterprise applications (including open-source stacks)</li>
//           <li>Enterprise websites and web applications (public-facing or internal portals)</li>
//           <li>Kubernetes (K8s) platforms for containerization and microservices</li>
//           <li>VDI-ready hosting (secure virtual desktops for remote work and controlled access)</li>
//         </ul>
//       )
//     },
//     {
//       image: AP,
//       title: "Security-first cloud with Zero Trust approach",
//       description: (
//         <>
//           <p>We design security onto the platforms, not as an add-on. Our hosting key controls can include:</p>
//           <ul>
//             <li>Zero Trust access principles (least privilege, continuous verification)</li>
//             <li>MFA + role-based access control for administrators and users</li>
//             <li>Firewall policies and traffic segmentation to isolate workloads</li>
//             <li>SSL-VPN / secure access gateways where required</li>
//             <li>Vulnerability scanning and hardening aligned to best practices</li>
//             <li>IPS/IDS, IOC-based monitoring for threat detection</li>
//             <li>Ransomware resilience with immutable/secure backup options and recovery workflows</li>
//           </ul>
//         </>
//       )
//     },
//     {
//       image: HW,
//       title: "Pricing and quote",
//       description: (
//         <>
//           <p>
//             Our secure hosted solutions are designed to be cost-effective compared to others for many enterprise workloads, with predictable monthly pricing and support options. You can choose from a wide variety of Virtual Machine Configuration and Storage Performance classes configured for specific types of workloads for your business needs.
//           </p>
//           <p>For a quick customized quote, contact info@synectiks.com.</p>
//         </>
//       )
//     },
//     {
//       image: efficientStorage,
//       title: "Storage, backup, and disaster recovery",
//       description: (
//         <ul>
//           <li>Object storage (S3-compatible) and scalable capacity from TBs to PBs</li>
//           <li>High-performance SSD block storage for servers and VDI workloads</li>
//           <li>Backup options for servers, VMs, endpoints, and critical apps</li>
//           <li>Disaster recovery options (backup-based restore or DR replication—based on RPO/RTO needs)</li>
//           <li>Cyber protection features integrated into backup/DR to reduce ransomware impact</li>
//         </ul>
//       )
//     },
//     {
//       image: WO,
//       title: "Networking and geo-resilience",
//       description: (
//         <ul>
//           <li>Each location is separated by Seismic Zone, Power Grid to make sure your Infrastructure is always available when disaster strikes at one location.</li>
//           <li>Secure networking design (subnets, segmentation, routing, and policy-based controls)</li>
//           <li>Locations can be selected to reduce correlated risk (power grid, seismic zone separation)</li>
//           <li>Options for multi-site DR and geo-backup based on recovery needs</li>
//         </ul>
//       )
//     },
//     {
//       image: EA,
//       title: "Self-service portal (governance with simplicity)",
//       description: (
//         <>
//           <p>Manage and control your hosted environment through an easy portal:</p>
//           <ul>
//             <li>Provision and manage compute, storage, backup, and DR</li>
//             <li>View security status, policies, and operational controls</li>
//             <li>Track usage and billing visibility for cost management</li>
//           </ul>
//         </>
//       )
//     },
//     {
//       image: protection,
//       title: "Compliance and governance (SoC2 & HIPAA)",
//       description: (
//         <>
//           <p>We support compliance-driven hosting by enabling:</p>
//           <ul>
//             <li>Access logging and audit trails</li>
//             <li>Security baseline controls and documented processes</li>
//             <li>Backup/retention policies aligned to business and regulatory needs</li>
//             <li>Support for meeting common enterprise compliance expectations (as applicable)</li>
//             <li>Security Awareness Training (SAT)</li>
//           </ul>
//         </>
//       )
//     },
//     {
//       image: cloud,
//       title: "Migration and modernization",
//       description: (
//         <>
//           <p>Our teams support both lift-and-shift and transformation programs:</p>
//           <ul>
//             <li>Cloud migration planning (application discovery, risk assessment, phased cutover)</li>
//             <li>Modernization using cloud-native patterns (containers, microservices, managed services)</li>
//             <li>Performance and security validation after migration</li>
//             <li>Outcome-focused delivery aligned to reliability, scalability, and cost control</li>
//           </ul>
//         </>
//       )
//     },
//     {
//       image: support,
//       title: "24x7 Support",
//       description: (
//         <ul>
//           <li>24/7/365 operations support with onshore and offshore coverage</li>
//           <li>Incident response coordination, escalation, and recovery support</li>
//           <li>Proactive monitoring for availability, performance, and security signals</li>
//         </ul>
//       )
//     }
//   ];

//   return (
//     <div className="disastercards-section">
//       <div className="disastercards-grid">
//         {cardData.map((card, index) => (
//           <FeatureCard
//             key={index}
//             image={card.image}
//             title={card.title}
//             description={card.description}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Cards;








import React from 'react';
import FeatureCard from '../../../../styles/FeatureCard.js';// Ensure path is correct
import '../../../../styles/disasterCard.css'; // Ensure CSS is imported

// Import your images...
import agent from '../../../../assets/services/hostedinfrastructure/icons/multilayered.png';
import AP from '../../../../assets/services/hostedinfrastructure/icons/selfportal.png';
import HW from '../../../../assets/services/hostedinfrastructure/icons/affordablepricing.png';
import efficientStorage from '../../../../assets/services/hostedinfrastructure/icons/storage.png';
import WO from '../../../../assets/services/hostedinfrastructure/icons/multisecuregeolocations.png';
import EA from '../../../../assets/services/hostedinfrastructure/icons/availability.png';
import protection from '../../../../assets/services/hostedinfrastructure/icons/securebackup.png';
import support from '../../../../assets/services/hostedinfrastructure/icons/support.png';
import cloud from '../../../../assets/services/hostedinfrastructure/icons/cloudmigration.png';

const Cards = () => {
  const cardData = [
    {
      image: agent,
      title: "What can you host?",
      description: (
        <ul>
          <li>Linux and Windows servers for business workloads</li>
          <li>Databases and enterprise applications (including open-source stacks)</li>
          <li>Enterprise websites and web applications (public-facing or internal portals)</li>
          <li>Kubernetes (K8s) platforms for containerized and microservices‑based workloads </li>
          <li>VDI‑ready hosting for secure virtual desktops and controlled access </li>
        </ul>
      )
    },
    {
      image: AP,
      title: "Security-first cloud with Zero Trust approach",
      description: (
        <>
          <p>Security is designed into the platform - not added later. Our hosting controls include: </p>
          <ul>
            <li>Zero Trust access principles (least privilege, continuous verification)</li>
            <li>MFA + role-based access control for administrators and users</li>
            <li>Firewall policies and traffic segmentation to isolate workloads</li>
            <li>SSL‑VPN or secure access gateways where required </li>
            <li>Vulnerability scanning and hardening aligned with industry best practices </li>
            <li>IPS/IDS and IOC‑based monitoring for threat detection </li>
            <li>Ransomware resilience with immutable backups and secure recovery workflows </li>
          </ul>
        </>
      )
    },
    {
      image: HW,
      title: "Pricing and quote",
      // This card has no bullets, so we want it centered:
      centered: true,
      description: (
        <>
          <p>
            Our secure hosted solutions are designed to be cost‑effective for enterprise workloads, with predictable monthly pricing and flexible support options. Choose from a wide range of VM configurations and storage performance tiers tailored to your business needs.
          </p>
          <p>For a customized quote, contact info@synectiks.com. </p>
        </>
      )
    },
    {
      image: efficientStorage,
      title: "Storage, backup, and disaster recovery",
      description: (
        <ul>
          <li>S3‑compatible object storage with scalable capacity from TBs to PBs </li>
          <li>High‑performance SSD block storage for servers and VDI workloads </li>
          <li>Backup options for servers, VMs, endpoints, and critical applications </li>
          <li>Disaster recovery options (backup‑based restore or DR replication based on RPO/RTO needs) </li>
          <li>Integrated cyber protection features to reduce ransomware impact </li>
        </ul>
      )
    },
    {
      image: WO,
      title: "Networking and geo-resilience",
      description: (
        <ul>
          <li>Each location is separated by seismic zone and power grid to ensure availability during regional disasters </li>
          <li>Secure networking design (subnets, segmentation, routing, policy‑based controls) </li>
          <li>Location selection to reduce correlated risk (power grid, seismic zone separation) </li>
          <li>Multi‑site DR and geo‑backup options based on recovery requirements </li>
        </ul>
      )
    },
    {
      image: EA,
      title: "Self-service portal (governance with simplicity)",
      description: (
        <>
          <p>Manage your hosted environment through an intuitive portal: </p>
          <ul>
            <li>Provision and manage compute, storage, backup, and DR </li>
            <li>View security status, policies, and operational controls </li>
            <li>Track usage and billing for cost visibility and optimization </li>
          </ul>
        </>
      )
    },
    {
      image: protection,
      title: "Compliance and governance (SOC 2 & HIPAA)",
      description: (
        <>
          <p>We support compliance‑driven hosting by enabling: </p>
          <ul>
            <li>Access logging and audit trails </li>
            <li>Security baseline controls and documented processes </li>
            <li>Backup and retention policies aligned with regulatory needs </li>
            <li>Support for common enterprise compliance expectations </li>
            <li>Security Awareness Training (SAT) </li>
          </ul>
        </>
      )
    },
    {
      image: cloud,
      title: "Migration and modernization",
      description: (
        <>
          <p>Our teams support both lift‑and‑shift and modernization initiatives: </p>
          <ul>
            <li>Cloud migration planning (application discovery, risk assessment, phased cutover) </li>
            <li>Modernization using cloud‑native patterns (containers, microservices, managed services) </li>
            <li>Performance and security validation post‑migration </li>
            <li>Outcome‑focused delivery aligned with reliability, scalability, and cost control </li>
          </ul>
        </>
      )
    },
    {
      image: support,
      title: "24x7 Support",
      description: (
        <>
          <p>
            Synectiks provides 24/7/365 operations support for hosted servers, databases, enterprise applications, Kubernetes platforms, AWS workloads, and virtual desktop environments.
          </p>
          <p>
            We continuously monitor compute, storage performance, network health, and security controls - including firewalls, segmentation, and threat indicators - to prevent outages and keep services responsive.
          </p>
          <p>
            Our team handles incident response, escalations, patching, upgrades, and capacity planning with defined SLAs and clear communication. Backup and disaster recovery readiness is maintained to ensure rapid, safe restoration during incidents. Compliance needs are supported through access controls, audit logs, documented processes, and governance reporting aligned with SOC 2 and HIPAA expectations.
          </p>
          <p>
            Synectiks provides 24/7/365 operations support for hosted servers, databases, enterprise applications, Kubernetes platforms, AWS workloads, and virtual desktop environments. Paragraph locked by Srujana Kodali
          </p>
          <p>
            We continuously monitor compute, storage performance, network health, and security controls - including firewalls, segmentation, and threat indicators - to prevent outages and keep services responsive. Paragraph locked by Srujana Kodali
          </p>
          <p>
            Our team handles incident response, escalations, patching, upgrades, and capacity planning with defined SLAs and clear communication. Backup and disaster recovery readiness is maintained to ensure rapid, safe restoration during incidents. Compliance needs are supported through access controls, audit logs, documented processes, and governance reporting aligned with SOC 2 and HIPAA expectations. Paragraph locked by Srujana Kodali
          </p>
        </>
      )
    }
  ];

  return (
    <div className="disastercards-section">
      <div className="disastercards-grid">
        {cardData.map((card, index) => (
          <FeatureCard
            key={index}
            image={card.image}
            title={card.title}
            description={card.description}
            centered={card.centered} // Pass the prop here
          />
        ))}
      </div>
    </div>
  );
};

export default Cards; 